<template>
	<li>
		<a-badge :count="coutMsg" dot>
			<img  src="@/assets/img/main/icon-tx.png"  @click="showMsgBox()" />
		</a-badge> 
		<a-modal 
			title="我的消息" 
			class="msgModal" :class="modelClassMore"
			:dialog-style="dialogStyle"
			v-model="visible" 
			:footer="null" 
			@ok="handleOk" @cancel="handleOk" >
			  <div class="listDataDiv">
				  <template v-if="listData.length>0">
					  <a-row class="msg-item" v-for="(item,index) in listData" :key="index">
						  <a-col class="msg-tip">
							  您有新的文档请查看 
							  <template v-if="item.read_at==null">
								  <span><a-badge status="error"  /></span>
							  </template>
						  </a-col>
						  <a-col class="msg-title">
								  <a-row> 
									  <a-col :span="23" class="msg-title-cont"  @click="toDetail(item.id,item.article_class_id)">
										  <img  :src="'/assets/img/main/icon-'+item.file_url_type+'.png'" alt="" /> {{item.title}}
										  <div  class="msg-addtime" v-if="isMore==true">
											   {{item.created_at}}  发布
										  </div>
									  </a-col>
									  <a-col :span="1" class="msg-title-right"><a-icon type="right" /></a-col>
								  </a-row>
						  </a-col>
						  <a-col  class="msg-addtime" v-if="isMore==false">
							  {{item.created_at}} 
						  </a-col>
					  </a-row>
				  </template>
				  <template v-if="listData.length<=0">
					  <div class="empty-div">
						  <img src="@/assets/img/main/empty-pic2.png" />
						  <span>暂无消息</span>
					  </div>
				  </template>
			  </div>
			  <div class="footerM">
				  <a-row>
					  <a-col :span="12" class="rightB"><span class="btntxt color-blue"  @click="setAllRead()">全部已读</span></a-col>
					  <a-col :span="12" class="rightC">
						  <template v-if="isMore==false">
							  <span class="btntxt"  @click="showMoreMsg()">查看更多</span>
						  </template>
						  <template v-if="isMore==true">
						  		<div class="paginationdiv">
									<a-pagination  size="small" :pageSize="pagination.pageSize" :total="pagination.total" @change="onChangeV" />
								</div>
						  </template>
					  </a-col>
				  </a-row>
			  </div>
		</a-modal>
	</li>
</template>

<script> 

import { mapActions } from 'vuex'; 
import {getCFileType,getArtItem,findById} from '@/utils/util'

export default {
  data() {
    return {
		visible: false,
		isMore:false,
		modelClassMore:"",
		dialogStyle:{ top: '8%',right:'-29%',transition:'all 0.3s' },
		listData:[],
		coutMsg:0,
		
		pagination:{
		  current:1,//当前页
		  total:0,
		  pageSize:4, 
		},
    };
  },
  computed:{
	  useridVal(){
		  return this.$store.state.user.userid;
	  },
	  userinforVal(){
		  return this.$store.state.user.info;
	  }
  },
  watch:{
	  // 使用watch来监听 响应数据的变化
  },
  components: {
    // TyphoonInfoTreeSelect,
  }, 
  props: {
	  //接受父组件传值
  },
  created() {	  
  },
  mounted(){
	//页面初始化
	var _self=this;
	var token=this.$store.state.user.token; 
	_self.$store.dispatch("article/UnreadCount").then(res=>{
		_self.coutMsg=res.datas;
		console.log("mounted----_self.coutMsg",this.coutMsg)
	});
  }, 
  methods: { 	  
	  //响应事件
	  showMsgBox(){
		this.visible=true;
		this.requestV(1,3);
		return;  
	  },
	  handleOk(){
		  this.dialogStyle={ top: '8%',right:'-29%',transition:'all 0.3s' };
		  this.isMore=false;
		  this.visible=false;
		  this.modelClassMore="";
		  console.log("handleOk----------");
		  
		  var _self=this;
		  var token=this.$store.state.user.token; 
		  _self.$store.dispatch("article/UnreadCount").then(res=>{
		  	_self.coutMsg=res.datas;
		  	console.log("handleOk----_self.coutMsg",this.coutMsg)
		  });
		  return;  
	  },
	  //显示更多
	  showMoreMsg()
	  {
		this.isMore=true;
		this.dialogStyle={right:'0%',transition:'all 0.3s' };
		this.modelClassMore="morelist";
		this.requestV(1,this.pagination.pageSize);
	  },	  
	  onChangeV(page, pageSize){
		  var _self=this;
		  _self.pagination.current=page;
		  _self.requestV(page,_self.pagination.pageSize);	
	  },
	  requestV(page,pagesize)
	  {
			var _self=this;
			_self.$store.dispatch("article/MyMessageList",{page:page,pagesize:pagesize}).then(res=>{
				//console.log("res:",res);
				var listData=res.datas.data;
				for(var i=0;i<listData.length;i++)
				{
					listData[i].file_url_type=getCFileType(listData[i].file_name);
				}
				_self.listData=listData;
				_self.pagination.total=res.datas.total;
			});
	  },
	  toDetail(id,cat){
		 // id=data ;		
		 var qid=this.$route.query.id;
		 
		this.$store.dispatch("article/SetMarkAsRead",{ids:[id],is_read_all:0});	  
		this.visible=false;
			  
		 var resData=this.listData;			 
		 var seltMsgItem=getArtItem(resData,id);
		 seltMsgItem.cat=seltMsgItem.article_class_id;
		 seltMsgItem.src=seltMsgItem.kk_preview_url; 
		 
		 var article_id=seltMsgItem.article_id;
		 console.log("qid-article_id:",qid+"--"+seltMsgItem.article_id);
		 if(qid==article_id)
		 {
		 	return;
		 }
		 
		 var menuListData=this.$store.state.article.menuList;
		 var menuRow=findById(menuListData,cat);
		 //console.log("tx-toDetail---1-menuRow:",menuRow);
		 var seltMenuItemVal={id:menuRow.id,name:menuRow.name};
		 this.$store.commit("article/set_seltMenuItem",seltMenuItemVal);
		 
		 console.log("tx-toDetail---1:",seltMsgItem);
		 seltMsgItem.id=article_id;
		 this.$store.commit("article/set_seltArtItem",seltMsgItem);
		 this.$router.push({path:'/detail',query:{id:seltMsgItem.article_id}});//
		//  var params={
		//  	id:cat,
		//  	page:1,
		//  	pageSize:100, 
		//  	istype:"curpage",
		//  };
		// console.log("dblclick---1:",seltMsgItem);
		//  this.$store.dispatch("article/GetArticleList",params).then(res=>{
		// 	 //console.log("-------------------res.datas.data:",res.datas.data);
		// 	resData=res.datas.data;
		// 	var seltArtItem=getArtItem(resData,seltMsgItem.article_id);
		// 	console.log("dblclick---2:",seltArtItem);
		// 	this.$store.commit("article/set_seltArtItem",seltArtItem);
		// 	this.$router.push({path:'/detail',query:{id:seltMsgItem.article_id}});//
		//  });
		 
		 
	 },
	 setAllRead(){
		 var _self=this;
		 var ids=[];
		 for(var i=0;i<_self.listData.length;i++)
		 {
			 ids.push(_self.listData[i].id);
		 }
		 _self.$store.dispatch("article/SetMarkAsRead",{ids:ids,is_read_all:1}).then(res=>{
			 console.log(res);
			 this.$message.success(res.errmsg);			 
			 var listData=_self.listData;		  
			 for(var i=0;i<listData.length;i++)
			 {
				 listData[i].read_at="1";
			 }
			 console.log("listData:",listData);
			 _self.listData=listData;
			 
			 _self.$store.dispatch("article/UnreadCount").then(res=>{
			 	_self.coutMsg=res.datas;
			 });
			 
		 });
	 },
		
		
  },
};
</script>

<style lang="scss" scoped> 
	img{ max-width: 24px; max-height: 24px;}
	.msgModal{
		width: 280px;
		.msg-item{padding-top: 0px; padding-bottom: 12px;}
		.msg-tip{ font-size: 16px; line-height: 22px; font-weight: 400;color: rgba(25, 26, 26, 1);}
		.msg-title{ 
			border-radius: 3px; background-color: rgba(241, 241, 243, 1);
			padding: 4px; padding-left:7px; padding-right: 7px; 
			margin-top: 8px; margin-bottom: 6px;
			align-items:baseline!important;
			img{ width: 16px; height: 16px; display: inline-block;}
			.msg-title-cont{ 
				font-size: 14px; line-height: 20px; height: 20px; color:rgba(25, 26, 26, 1);
				overflow: hidden;
				text-overflow: ellipsis;
				white-space: nowrap;
			}
			.msg-title-right{ text-align: right;}
		 }
		 .msg-addtime{color:rgba(101, 101, 102, 1);font-size: 12px; line-height: 20px; }
		.footerM{ 
			position: absolute;left: 0px;bottom: 0px; height: 51px;width: 100%;  border-top: solid 1px rgba(226, 227, 231, 1);
			.ant-row{ 
				height: 100%; text-align: center;
				.rightB{ border-right: solid 1px rgba(226, 227, 231, 1);}
			}
			
			.btntxt{font-size: 16px; line-height: 51px; font-weight: 400; color:rgba(25, 26, 26, 1);}	
			.color-blue{color:rgba(31, 110, 238, 1)}
		}
		.empty-div{ 
			text-align:center; line-height: 40px; font-size: 14px; font-weight: 400;
			img{max-width: 173px; max-height: 173px; height: auto; margin: 0px auto;}
		}
	}
	 .morelist {
		 transition:all 0.3s;
		 .msg-title{ 
			 height: auto;
			 .msg-title-cont{ 
				 height: auto;
				 .msg-addtime{ padding-left: 20px; margin-top:5px; font-size: 14px;}
			 } 
		 }
		 .footerM{
			 .rightB{ text-align: left; padding-left: 20px; border-right:unset!important;}
		 }
		 .paginationdiv{ text-align: right;padding-right: 10px;padding-top: 13px;}
	 }
</style>
<style>
	.msgModal .ant-modal{width: 280px!important;}
	.msgModal .ant-modal-header{padding-top: 10px; padding-bottom: 10px; padding-left: 15px;}
	.msgModal .ant-modal-close-x{ width: 43px;height: 43px;line-height: 43px;}
	.msgModal .ant-modal-title{ font-size: 16px;  font-weight: 700; color:rgba(25, 26, 26, 1); }
	.msgModal .ant-modal-body{padding: 10px; padding-bottom: 70px;}
	
	
	.morelist .ant-modal{width: 770px!important;} 
	.morelist .rightB{width: 20%;}
	.morelist .rightC{width: 80%;}
	.paginationdiv .ant-pagination-jump-next-custom-icon,.paginationdiv .ant-pagination-jump-prev-custom-icon {min-width:40px!important;}
	.paginationdiv .ant-pagination-item-ellipsis{letter-spacing:0px!important;font-size: 12px;}
</style>